import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Standard } from '@getvim/vim-connect';
import { isEmpty } from 'lodash-es';
import useLocalStorage from 'react-localstorage-hook';
import { OrdersViewed } from '../../mocks/standard-events';
import { FlexBox } from '../common/FlexBox';
import { MonacoEditor } from '../monaco-editor';

export const OrdersViewedTab = () => {
  const [payload, setPayload] = useState<Standard.Events.OrdersViewedPayload>();
  const [predefinedPayload, setPredefinedPayload] = useState<string>('');
  const [lastUsedPayload, setLastUsedPayload] = useLocalStorage('lastOrdersViewedPayload', '');
  const [, setShouldPublish] = useLocalStorage('shouldPublishOrdersViewed', false);

  useEffect(() => {
    handlePredefinedPayloadChange({ target: { value: lastUsedPayload } } as SelectChangeEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShouldPublish(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePublish = () => setShouldPublish(true);

  const handlePredefinedPayloadChange = ({ target: { value } }: SelectChangeEvent) => {
    setPredefinedPayload(value);
    setLastUsedPayload(value);
    setPayload(OrdersViewed.predefinedPayloads[value]);
  };

  return (
    <Accordion id="ordersViewedTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>ordersViewed</Typography>
        <Select
          displayEmpty
          value={predefinedPayload}
          size="small"
          id="order-viewed-select"
          onChange={handlePredefinedPayloadChange}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MenuItem value="">Choose</MenuItem>
          {Object.keys(OrdersViewed.predefinedPayloads).map((value) => (
            <MenuItem value={value} key={value} id={`order-viewed-${value.replaceAll(' ', '-')}`}>
              {value}
            </MenuItem>
          ))}
        </Select>

        <Button
          id="publish-orders-viewed"
          disabled={isEmpty(predefinedPayload)}
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish();
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails id="ordersViewedAccordionDetails">
        <MonacoEditor onChange={setPayload} height="20rem" value={payload} />

        <FlexBox>
          <TextField
            id="ordersViewedPayload"
            variant="outlined"
            size="small"
            value={JSON.stringify(payload)}
            sx={{ display: 'none' }}
          />
        </FlexBox>
        <FlexBox style={{ justifyContent: 'space-between' }}>
          <div id="ordersViewedAccordionDetails-inject-labs" />
          <div id="ordersViewedAccordionDetails-inject-di" />
        </FlexBox>
      </AccordionDetails>
    </Accordion>
  );
};
